<template>
    <div>
        <div class="row">
            <base-button type="default" class="pull-right" size="sm" @click="$router.push('/projects-list')">Inapoi</base-button>
        </div>
        <br>
        <div v-if="project" class="row">
            <div class="col-md-8">
                <card :title="'Date Proiect'">
                    <strong>Lucrari:</strong>
                    <p>{{project.lucrari}}</p>
                    <strong>Adresa:</strong>
                    <p><strong>Strada:</strong> {{project.lucrare_str}} <b>,Nr.</b> {{project.lucrare_nr_str}},
                        <strong>Judet</strong> {{project.lucrare_judet}},
                        <strong>Oras:</strong> {{project.lucrare_oras}},
                        <strong>Sat:</strong> {{project.lucrare_sat}},
                        <strong>Cod postal:</strong> {{project.lucrare_cod_postal}},
                        <strong>Bloc:</strong> {{project.lucrare_bloc}},
                        <strong>Scara:</strong> {{project.lucrare_scara}},
                        <strong>Etaj:</strong> {{project.lucrare_etaj}},
                        <strong>Apartament:</strong> {{project.lucrare_apt}}
                    </p>
                    <br>
                    <div class="row">
                        <div class="col">
                            <strong>Valoare lucrari:</strong>
                            <p>{{project.valoare}}</p>
                        </div>
                        <div class="col">
                            <strong>Executant:</strong>
                            <p>{{project.executant}}</p>
                        </div>
                        <div class="col">
                            <strong>Proiectant:</strong>
                            <p>{{project.proiectant}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <strong>Numar si data autorizatie:</strong>
                            <p>{{project.nr_aut}} / {{project.data_aut}}</p>
                        </div>
                        <div class="col">
                            <strong>Numar proiect:</strong>
                            <p>{{project.nr_proiect}}</p>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col">
                            <strong>Numar cf:</strong>
                            <p>{{project.cf}}</p>
                        </div>
                        <div class="col">
                            <strong>Numar fisa imobil:</strong>
                            <p>{{project.fisa_imobil}}</p>
                        </div>
                        <div class="col">
                            <strong>Numar cadastral:</strong>
                            <p>{{project.nr_cad}}</p>
                        </div>
                        <div class="col">
                            <strong>Numar topo:</strong>
                            <p>{{project.nr_topo}}</p>
                        </div>
                    </div>
                    <br>
                </card>
            </div>
            <div class="col-md-4" v-if="project.customer">
                <card class="stacked-form" title="Date client">
                    <strong>Nume:</strong>
                    <p>{{project.customer.nume}}</p>
                    <strong>CNP/CUI:</strong>
                    <p>{{project.customer.cnp}}</p>
                    <strong>Telefon:</strong>
                    <p>{{project.customer.tel}}</p>
                    <strong>Email:</strong>
                    <p>{{project.customer.email}}</p>
                    <strong>Adresa:</strong>
                    <p><strong>Strada:</strong> {{project.customer.strada}} <b>,Nr.</b> {{project.customer.nr_str}},
                        <strong>Judet</strong> {{project.customer.judet}},
                        <strong>Oras:</strong> {{project.customer.oras}},
                        <strong>Sat:</strong> {{project.customer.sat}},
                        <strong>Cod postal:</strong> {{project.customer.cod_postal}},
                        <strong>Bloc:</strong> {{project.customer.bloc}},
                        <strong>Scara:</strong> {{project.customer.scara}},
                        <strong>Etaj:</strong> {{project.customer.etaj}},
                        <strong>Apartament:</strong> {{project.customer.apt}}
                    </p>
                    <br>
                </card>
            </div>
        </div>
        <div class="row">
            <card class="card">
                <h4 slot="header" class="card-title">Formulare</h4>
                <div v-if="project">
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">Formulare Primaria Cluj-Napoca</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th scope="row"><p>Comunicare incepere lucrari - Primaria Cluj-Napoca</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-incepere/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Comunicare incheiere lucrari - Primaria Cluj-Napoca</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-incheiere/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Cerere eliberare certificat de atestare a edificarii- Primaria Cluj-Napoca</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-edificare/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Declaratie privind valoarea reala a lucrarilor executate</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-declaratie-val/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Proces-verbal de recepție la terminarea lucrărilor</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-receptie/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">Formulare ISC</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th scope="row"><p>Comunicare incepere lucrari - ISC</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-incepere-isc/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Comunicare incheiere lucrari - ISC</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-incheiere-isc/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Cerere de avizare program controlul calitatii lucrarilor in faze determinante</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-program-cc/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">Formulare generale</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th scope="row"><p>Comunicare incepere lucrari</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-incepere-general/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Comunicare incheiere lucrari</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-incheiere-general/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Declaratie privind valoarea reala a lucrarilor executate</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-declaratie-valoare-general/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Ordin de incepere a lucrarilor</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-ordin-incepere/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><p>Decizie de numire</p></th>
                            <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                   :href="baseDocumentGenerationUrl + '/generate-decizie-numire/' + project.id"
                                   target="_blank"
                                   v-tooltip="'Deschide formular'">
                                <i class="tim-icons icon-cloud-download-93"></i>
                            </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">Cartea constructiei</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row"><p>Coperta cartea constructiei</p></th>
                                <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                       :href="baseDocumentGenerationUrl + '/generate-coperta/' + project.id"
                                       target="_blank"
                                       v-tooltip="'Deschide formular'">
                                    <i class="tim-icons icon-cloud-download-93"></i>
                                </a>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row"><p>Cartea constructiei (xlsx)</p></th>
                                <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                       :href="baseDocumentGenerationUrl + '/generate-carte/' + project.id"
                                       target="_blank"
                                       v-tooltip="'Descarca excel cartea constructiei'">
                                    <i class="tim-icons icon-cloud-download-93"></i>
                                </a>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row"><p>Condica pentru evidenta betoanelor turnate</p></th>
                                <td><a class="btn btn-icon btn-sm btn-warning pull-right"
                                       :href="baseDocumentGenerationUrl + '/generate-condica/' + project.id"
                                       target="_blank"
                                       v-tooltip="'Deschide formular'">
                                    <i class="tim-icons icon-cloud-download-93"></i>
                                </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProjectView.vue",
        props: ['project', 'baseDocumentGenerationUrl'],
        return:{
            user: {
                name: "",
                email: "",
            },
            project: {
                customer: {}
            }
        },
        created() {
            this.getProfile();
        },

        methods: {
            async getProfile() {
                this.user = this.$store.state.user;
            }
        }
    }
</script>

<style scoped>
    p strong {
        font-weight: bolder;
        color: #525f7f;
        font-size: 0.8rem;
    }
</style>